module.exports = __webpack_public_path__ + "./static/img/about-us.927c6714f0177de1b40ef9d13c1779e9.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/fontawesome/about-us.png
// module id = ./client/src/assets/fontawesome/about-us.png
// module chunks = 0